import React from 'react';
import { Input, Select, Form, Space } from 'antd';
import type { Money } from '@/types/common';
import { currencyOptions } from '@/constants/currencyOptions';

interface CurrencyInputProps {
  value?: Money;
  onChange?: (value: Money) => void;
  label?: string;
  disabled?: boolean;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({ value, onChange, label, disabled }) => {
  const safeValue = value ?? { amount: 0, currency: 'USD' };
  
  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const amount = parseFloat(e.target.value) || 0;
    onChange?.({ ...safeValue, amount });
  };

  const handleCurrencyChange = (currency: string) => {
    onChange?.({ ...safeValue, currency });
  };

  return (
    <Form.Item label={label} style={{ marginBottom: 0 }}>
      <Space.Compact>
        <Select
          value={safeValue.currency}
          onChange={handleCurrencyChange}
          style={{ width: 120 }}
          disabled={disabled}
        >
          {currencyOptions.map((opt: { label: string; value: string }) => (
            <Select.Option key={opt.value} value={opt.value}>
              {opt.label}
            </Select.Option>
          ))}
        </Select>
        <Input
          type="number"
          value={safeValue.amount}
          onChange={handleAmountChange}
          style={{ width: 150 }}
          min={0}
          step={0.01}
          disabled={disabled}
        />
      </Space.Compact>
    </Form.Item>
  );
};

export default CurrencyInput; 